import { Options, Vue } from 'vue-class-component';

import config from '@/config/config';
import PageBaseView from '@/pages/PageBaseView';
import * as ProductTypeService from '@/services/product-type.service';
import { IProductType } from '@/domain/product-type.model';

@Options({
  name: 'product-type-view',
  props: {
    id: String,
  },
})
export default class ProductTypeView extends PageBaseView {
  public row: IProductType = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    this.url = 'product-type';
    this.module = config.modules.productType;

    ProductTypeService.get(this.id)
      .then((res: IProductType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }
}
